export default __webpack_public_path__ + "static/vest_image-2e4cf31c32a9f460fcfef23749775ed2.jpg";